<template>
  <div class="sender-card">
    <FriedH5 class="title">{{ $t('sender') }}</FriedH5>
    <FriedAvatar :name="sender.fullName" :thumb-url="sender.thumbUrl" />
    <div>
      <FriedH4>{{ name || sender.email }}</FriedH4>
      <FriedParagraph>{{ title }}</FriedParagraph>
      <FriedParagraph v-if="sender.mobile" size="small">{{ sender.mobile }}</FriedParagraph>
      <FriedParagraph v-if="!!name && sender.email" size="small">{{ sender.email }}</FriedParagraph>
    </div>
    <FriedButton
      v-if="isCallEnabled"
      class="call-button"
      data-external="signing-page-topbar-call-menu-item"
      button-type="tertiary"
      @click="$emit('call')"
    >
      <template #leftIcon>
        <FriedIcon icon="phone-call" />
      </template>
      {{ $t('call') }}
    </FriedButton>
  </div>
</template>
<script lang="ts">
import type { SigningPageUser } from '@getaccept/lib-shared/src/types/signing-page-user';
import type { PropType } from 'vue';
import { computed, defineComponent } from 'vue';
import { useI18n } from 'vue-i18n';

export default defineComponent({
  components: {},
  props: {
    sender: {
      type: Object as PropType<SigningPageUser>,
      required: true,
    },
    company: {
      type: String,
      default: '',
    },
    isCallEnabled: Boolean,
  },
  emits: ['call'],
  setup(props) {
    const { t } = useI18n();
    const name = computed(
      () =>
        props.sender.fullName ||
        `${props.sender.firstName || ''} ${props.sender.lastName || ''}`.trim()
    );
    const title = computed(() =>
      props.sender.title && props.company
        ? `${props.sender.title} ${t('role_at')} ${props.company}`
        : props.sender.title || props.company || ''
    );

    return { title, name };
  },
});
</script>
<style lang="scss" scoped>
.sender-card {
  border: 1px solid var(--gray-89);
  border-radius: var(--radius-medium);
  display: grid;
  grid-template-columns: auto 1fr auto;
  padding: var(--spacing-100);
  gap: var(--spacing-100);

  .title {
    grid-column: 1 / -1;
  }

  .call-button {
    place-self: flex-start;
  }
}
</style>
